import { Card, Grid, styled } from "@mui/material";

export const TimelinePage = styled("div")(({dark}) => ({
  width: "100vw",
  // height: "calc(100vh + 150px )",
  height: 'fit-content',
  backgroundColor: dark? "#1C2028" :"#fff",
  //   backgroundColor: "red",
  // maxHeight: "calc(100vh + 150px)",
  maxWidth: "100vw",
  overflow: "hidden",
}));

export const TimelineScreen = styled("div")(({theme,dark}) => ({
  width: "100vw",
  // height: "calc(100vh - 50px)",
  height:'fit-content',
  padding: '20px 40px',
  display: 'flex',
  flexDirection:'column',

  '& .page-title':{
    fontSize:'3em',
    color: dark?"#FF3B81":"#3957D2",
    fontWeight:700,
    margin:"20px 0 0 0 "
  },
  '& .vertical-timeline-element-content':{
    backgroundColor:dark?"#22262E":"#fff",
    boxShadow:'0px 8px 20px rgba(35, 35, 35, 0.1)',
    color:dark? '#fff':'#000'
  },
  '& .vertical-timeline.vertical-timeline--two-columns:before':{
    backgroundColor:dark?"#FF3B81":"#3957D2",
  },
  '& .vertical-timeline-element-icon':{
    boxShadow:'0px 8px 20px rgba(35, 35, 35, 0.1)',
    // backgroundColor:'#fff',

  },
  [theme.breakpoints.down("md")]: {
    "& .page-title": {
      fontSize: "2em",
      marginBottom:'30px',
    },
  },
}));